// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navbar_wrapper__3AFU4","container":"Navbar_container__Stw5O","icon":"Navbar_icon__dXO0O","beta-text":"Navbar_beta-text__2_ift"};